import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import { GetBatchesDataResponse } from '../../type'
import BatchTable from '../BatchTable'

interface BatchListingProps {
	data: GetBatchesDataResponse[]
	total: number
	isLoading?: boolean
}

export default function BatchListing({
	data,
	total,
	isLoading,
}: BatchListingProps) {
	return (
		<Card>
			<CardHeader>
				<CardTitle>ชุดคูปอง</CardTitle>
			</CardHeader>
			<CardContent>
				<BatchTable data={data} total={total} isLoading={isLoading} />
			</CardContent>
		</Card>
	)
}
